import {InputAction, InputState, KeyActionType, KeyDownAction, KeyUpAction} from "../input";
import {CodeAction, CodeActionType, CodeState, SetCodeAction} from "./types";

const initialCodeState: CodeState = {
    code: []
};

export const code = (
    state: CodeState = initialCodeState,
    action: CodeAction
): CodeState => {
    switch (action.type) {
        case CodeActionType.SETCODE:
            const scap = (action as SetCodeAction).payload
            return { ...state, code: scap};

        default:
            return state;
    }
};